import { render, staticRenderFns } from "./myPsRepair.vue?vue&type=template&id=be7b0ebe&scoped=true&"
import script from "./myPsRepair.vue?vue&type=script&lang=js&"
export * from "./myPsRepair.vue?vue&type=script&lang=js&"
import style0 from "./myPsRepair.vue?vue&type=style&index=0&id=be7b0ebe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7b0ebe",
  null
  
)

export default component.exports